"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[5507],{

/***/ 62790:
/***/ (() => {

// extracted by mini-css-extract-plugin


/***/ }),

/***/ 86358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Text = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", ({ $theme })=>({
        ...$theme.typography.body,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 77780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ Link),
/* harmony export */   x: () => (/* binding */ isInternalURL)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);
/* harmony import */ var _icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12586);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45916);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67710);




const base = typeof window !== "undefined" ? new URL(`${window.location.protocol}//${window.location.host}`) : new URL("https://app.gadget.dev");
function isInternalURL(url) {
    try {
        return new URL(url, base).hostname === base.hostname;
    } catch (error) {
        return true;
    }
}
const Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const internal = props.external ? false : isInternalURL(props.href);
    const overrides = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        BaseButton: {
            style: ({ $theme })=>{
                return {
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    paddingTop: props.compact ? "0px" : undefined,
                    paddingBottom: props.compact ? "0px" : undefined,
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    fontFamily: "inherit",
                    whiteSpace: "no-wrap",
                    color: "inherit",
                    textDecoration: "underline",
                    ":hover:not(:disabled)": {
                        color: "inherit"
                    },
                    ":hover:not(:disabled):not(:active)": {
                        color: "inherit"
                    },
                    ":focus-visible": {
                        color: "inherit",
                        outlineOffset: "3px"
                    },
                    ":disabled": {
                        color: $theme.colors.alpha400,
                        backgroundColor: "transparent"
                    },
                    ":active:not(:disabled)": {
                        color: "inherit"
                    }
                };
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: "4px"
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
        ref: ref,
        kind: _Button__WEBPACK_IMPORTED_MODULE_2__/* .ButtonKind */ .Lv.tertiary,
        $as: "a",
        target: internal ? undefined : "_blank",
        endEnhancer: props.endEnhancer ?? internal ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_3__/* .ExternalLinkIcon */ .h, {
            $size: props.size == _Button__WEBPACK_IMPORTED_MODULE_4__/* .SIZE */ .NO.compact ? 12 : 16
        }),
        ...props,
        overrides: overrides
    });
});


/***/ }),

/***/ 6710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PZ: () => (/* binding */ CloseButton),
/* harmony export */   fe: () => (/* binding */ ModalBody),
/* harmony export */   u_: () => (/* binding */ Modal),
/* harmony export */   xB: () => (/* binding */ ModalHeader)
/* harmony export */ });
/* unused harmony export ModalFooter */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72221);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76988);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7237);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69525);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45199);
/* harmony import */ var _button_PlainButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77301);







const ModalHeader = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .xB, {
        $as: "header",
        ...props,
        $style: {
            ...$theme.typography.subHeading,
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            ...props.$style
        }
    });
};
const ModalBody = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .fe, {
        $as: "section",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            color: $theme.colors.contentPrimary,
            ...props.$style
        }
    });
};
const ModalFooter = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalFooter */ .mz, {
        $as: "footer",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .ds)($theme.sizing.scale600),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .i6)(0),
            display: "flex",
            gap: $theme.sizing.scale500,
            justifyContent: "end",
            alignItems: "center",
            ...props.$style
        }
    });
};
const Modal = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    const overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* .mergeOverrides */ .aO)({
        Close: {
            component: CloseButton
        },
        Dialog: {
            style: {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .uJ)("8px"),
                boxShadow: $theme.lighting.depth4
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        unstable_ModalBackdropScroll: true,
        ...props,
        overrides: overrides
    }, props.raw ? props.children : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalHeader, null, props.title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalBody, {
        $style: overrides.ModalBody?.style
    }, props.children), (props.footer || props.footerLeft) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalFooter, null, props.footerLeft && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            marginRight: "auto"
        })
    }, props.footerLeft), props.footer)));
};
const CloseButton = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_button_PlainButton__WEBPACK_IMPORTED_MODULE_6__/* .PlainButton */ .D, {
        ...props,
        type: "button",
        $style: {
            position: "absolute",
            top: $theme.sizing.scale500,
            right: $theme.sizing.scale500,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer"
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__/* .CloseIcon */ .T, null));
};


/***/ }),

/***/ 28418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: () => (/* binding */ WarningIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: "transparent"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};


/***/ }),

/***/ 75874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ Heading)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Heading = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("h1", ({ $theme })=>({
        ...$theme.typography.heading,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 29574:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: () => (/* binding */ CenteredSpin)
/* harmony export */ });
/* unused harmony export DelayedCenteredSpin */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60674);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



/** Renders a spinner that centers itself horizontally and vertically in the parent container */ const CenteredSpin = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            paddingLeft: $theme.sizing.scale600,
            paddingRight: $theme.sizing.scale600,
            paddingTop: $theme.sizing.scale600,
            paddingBottom: $theme.sizing.scale600,
            display: "flex",
            flexDirection: "column",
            gap: $theme.sizing.scale600,
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .StyledSpinnerNext */ .aN, {
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_3__/* .SIZE */ .N.large
    }), props?.children));
};
const DelayedCenteredSpin = (props)=>{
    const [showSpinner, setShowSpinner] = useState(false);
    const delay = props.delay ?? 0;
    useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowSpinner(true);
        }, delay ?? 0);
        return ()=>clearTimeout(timer);
    }, [
        delay
    ]);
    return showSpinner ? /*#__PURE__*/ React.createElement(CenteredSpin, null) : null;
};


/***/ }),

/***/ 3385:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ ErrorDisplay),
/* harmony export */   x: () => (/* binding */ DebugDisplay)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77780);
/* harmony import */ var _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68936);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94922);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10334);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61022);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4329);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26969);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79409);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76705);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30242);
/* harmony import */ var state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85221);











const ReactJson = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName () {
        return "react-json-view";
    },
    isReady (props1) {
        const key = this.resolve(props1);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>__webpack_require__.e(/* import() | react-json-view */ 2229).then(__webpack_require__.t.bind(__webpack_require__, 41575, 23)),
    requireAsync (props1) {
        const key = this.resolve(props1);
        this.resolved[key] = false;
        return this.importAsync(props1).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props1) {
        const id = this.resolve(props1);
        if (true) {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(41575);
        }
        return eval('require.resolve')("react-json-view");
    }
});
const Pre = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .styled */ .zo)("pre", ({ $theme: $theme1 })=>({
        fontFamily: _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__/* .monoFontFamily */ .CK,
        overflow: "auto",
        paddingLeft: $theme1.sizing.scale300,
        paddingRight: $theme1.sizing.scale300,
        paddingTop: $theme1.sizing.scale300,
        paddingBottom: $theme1.sizing.scale300,
        marginBottom: $theme1.sizing.scale400,
        borderRadius: $theme1.borders.radius200
    }));
const ErrorDisplay = (props1)=>{
    const [_css1, $theme1] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .hQ)();
    let output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(Pre, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label3 */ .T3, {
        $style: {
            color: $theme1.colors.negative500
        }
    }, (0,state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__/* .errorMessage */ .N3)(props1.error)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label4 */ .cV, {
        $style: {
            color: $theme1.colors.negative500
        }
    }, "stack" in props1.error ? props1.error.stack : "<stack unknown>"), props1.extra && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(DebugDisplay, {
        data: props1.extra
    }));
    if (props1.error.graphQLErrors) {
        const errorWithRemedy1 = lodash_find__WEBPACK_IMPORTED_MODULE_2___default()(props1.error.graphQLErrors, "extensions.remedy");
        if (errorWithRemedy1) {
            // This can't be null given the above `find` can only give us a truthy value if it is set
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const remedy1 = errorWithRemedy1.extensions.remedy;
            output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, null, output1, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .r, {
                href: remedy1.href
            }, remedy1.text));
        }
    }
    return output1;
};
const DebugDisplay = (props1)=>{
    const [css1] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .hQ)();
    let output1;
    if (lodash_isError__WEBPACK_IMPORTED_MODULE_3___default()(props1.data)) {
        output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
            error: props1.data
        });
    } else {
        let jsonString1;
        try {
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_4___default()(props1.data)) {
                output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("code", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("pre", null, props1.data));
            } else {
                let json1;
                if (props1.data) {
                    jsonString1 = fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default()(Object.prototype.hasOwnProperty.call(props1.data, "toJSON") ? props1.data.toJSON() : props1.data);
                    json1 = JSON.parse(jsonString1 ?? "{}");
                } else {
                    json1 = String(props1.data);
                }
                output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ReactJson, {
                    src: json1,
                    collapsed: 2,
                    collapseStringsAfterLength: 100
                });
            }
        } catch (e1) {
            output1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
                error: e1,
                extra: {
                    json: jsonString1
                }
            });
        }
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        className: css1({
            maxWidth: "1000px",
            ...props1.$style
        })
    }, output1);
};


/***/ }),

/***/ 65383:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* binding */ ErrorNavBar),
  T: () => (/* binding */ NotFound)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(63034);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(71567);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(45916);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(1462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ./src/components/MarketingButton.tsx


const MarketingButton = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement("button", {
        onClick: props.onClick,
        className: css({
            cursor: "pointer",
            display: "inline-block",
            WebkitBoxPack: "start",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            alignItems: "center",
            border: "2px solid #2525cf",
            borderRadius: "6px",
            transition: "150ms",
            fontFamily: "Inconsolata,monospace",
            textAlign: "left",
            backgroundColor: "#e2e2e2",
            color: "#0b171e",
            borderColor: "#919191",
            boxShadow: "inset 0 3px 0 0 #f1f1f1,inset 0 -4px 0 0 #ababab",
            padding: "13px 20px 15px",
            fontSize: "19px",
            ":hover": {
                outline: "0",
                paddingTop: "14px",
                paddingBottom: "14px",
                borderColor: "#7c7c7c",
                boxShadow: "inset 0 2px 0 0 #ababab,inset 0 -2px 0 0 #f1f1f1"
            },
            ":active": {
                outline: "0",
                paddingTop: "15px",
                paddingBottom: "13px",
                borderColor: "#636363",
                boxShadow: "inset 0 4px 0 0 #f1f1f1,inset 0 0 0 0 #fff"
            },
            ...props.$style
        })
    }, props.children);
};
/* harmony default export */ const components_MarketingButton = (MarketingButton);

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(45199);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/AccordionExpandIcon.tsx
var AccordionExpandIcon = __webpack_require__(9179);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/LogoutIcon.tsx


const LogoutIcon = (props)=>/*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M7.00015 0.600006C5.63752 0.600006 4.37791 1.03658 3.34494 1.76355C3.28762 1.80383 3.2388 1.85501 3.20127 1.91417C3.16373 1.97332 3.13821 2.03929 3.12617 2.1083C3.11413 2.17732 3.1158 2.24803 3.13108 2.3164C3.14637 2.38477 3.17497 2.44946 3.21525 2.50678C3.25554 2.56409 3.30672 2.61291 3.36587 2.65045C3.42503 2.68799 3.49099 2.71351 3.56001 2.72555C3.62902 2.73759 3.69974 2.73592 3.76811 2.72064C3.83648 2.70535 3.90117 2.67675 3.95848 2.63646C4.82311 2.02797 5.86464 1.66667 7.00015 1.66667C9.9519 1.66667 12.3335 4.04825 12.3335 7.00001C12.3335 9.95176 9.9519 12.3333 7.00015 12.3333C5.86464 12.3333 4.82311 11.972 3.95848 11.3635C3.84273 11.2822 3.69939 11.2501 3.56001 11.2745C3.42063 11.2988 3.29661 11.3775 3.21525 11.4932C3.13389 11.609 3.10185 11.7523 3.12617 11.8917C3.15049 12.0311 3.22919 12.1551 3.34494 12.2365C4.37791 12.9634 5.63752 13.4 7.00015 13.4C10.5284 13.4 13.4002 10.5283 13.4002 7.00001C13.4002 3.47176 10.5284 0.600006 7.00015 0.600006ZM2.72307 4.32813C2.58451 4.33226 2.453 4.39017 2.3564 4.48959L0.269941 6.57605C0.204601 6.62589 0.151662 6.69016 0.115255 6.76383C0.0788482 6.83751 0.0599582 6.9186 0.060059 7.00078C0.0601598 7.08297 0.0792489 7.16401 0.115836 7.2376C0.152424 7.31119 0.205521 7.37532 0.270983 7.42501L2.3564 9.51042C2.40554 9.56161 2.46441 9.60247 2.52954 9.63063C2.59468 9.65878 2.66478 9.67365 2.73573 9.67437C2.80669 9.67509 2.87707 9.66165 2.94277 9.63483C3.00846 9.60801 3.06814 9.56835 3.11832 9.51817C3.16849 9.468 3.20815 9.40832 3.23497 9.34262C3.26179 9.27693 3.27524 9.20654 3.27452 9.13559C3.27379 9.06463 3.25892 8.99453 3.23077 8.9294C3.20262 8.86426 3.16175 8.8054 3.11057 8.75626L1.88765 7.53334H7.53348C7.60416 7.53434 7.67432 7.52128 7.73991 7.49493C7.80549 7.46857 7.86518 7.42945 7.91551 7.37982C7.96584 7.3302 8.00581 7.27107 8.03309 7.20586C8.06037 7.14066 8.07441 7.07069 8.07441 7.00001C8.07441 6.92933 8.06037 6.85935 8.03309 6.79415C8.00581 6.72894 7.96584 6.66981 7.91551 6.62019C7.86518 6.57056 7.80549 6.53144 7.73991 6.50508C7.67432 6.47873 7.60416 6.46567 7.53348 6.46667H1.88765L3.11057 5.24376C3.18763 5.16884 3.24027 5.07239 3.26158 4.96705C3.2829 4.86171 3.27189 4.75238 3.23 4.6534C3.18811 4.55442 3.1173 4.47041 3.02684 4.41237C2.93638 4.35432 2.8305 4.32496 2.72307 4.32813Z",
        fill: "black"
    }));

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/stateful-menu.js + 5 modules
var stateful_menu = __webpack_require__(54274);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/stateful-popover.js + 1 modules
var stateful_popover = __webpack_require__(27801);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(64165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(61022);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js
var compact = __webpack_require__(6494);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(22764);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-gravatar@2.6.3_react@0.0.0-experimental-4ead6b530/node_modules/react-gravatar/dist/index.js
var dist = __webpack_require__(52069);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/components/auth/UserDropdown.tsx











const UserDropdown = (0,es/* observer */.Pi)((props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale200,
        className: css({
            ...props.$style
        })
    }, /*#__PURE__*/ react.createElement(stateful_popover/* default */.Z, {
        onOpen: ()=>setMenuOpen(true),
        onClose: ()=>setMenuOpen(false),
        placement: constants/* PLACEMENT */.r4.bottomRight,
        popoverMargin: 0,
        content: ({ close })=>/*#__PURE__*/ react.createElement(stateful_menu/* default */.Z, {
                overrides: {
                    Option: {
                        style: {
                            paddingTop: `calc(${$theme.sizing.scale200} - 1px)`,
                            paddingBottom: `calc(${$theme.sizing.scale200} - 1px)`,
                            color: $theme.colors.primaryA
                        }
                    }
                },
                items: compact_default()([
                    {
                        label: /*#__PURE__*/ react.createElement(Row/* Row */.X, {
                            $gap: $theme.sizing.scale400
                        }, /*#__PURE__*/ react.createElement(LogoutIcon, null), "Logout"),
                        onSelect: ()=>window.location.href = `${rootURL}/auth/logout`
                    }
                ]),
                onItemSelect: ({ item })=>{
                    item.onSelect();
                }
            })
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale500,
        className: css({
            paddingTop: $theme.sizing.scale200,
            paddingBottom: $theme.sizing.scale200,
            paddingLeft: $theme.sizing.scale300,
            paddingRight: $theme.sizing.scale300,
            ...(0,utils/* expandBorderRadii */.uJ)($theme.borders.radius200),
            backgroundColor: menuOpen ? $theme.colors.backgroundQuaternary : undefined,
            cursor: "pointer",
            userSelect: "none",
            overflow: "hidden",
            ":hover": {
                backgroundColor: $theme.colors.backgroundQuaternary
            }
        })
    }, /*#__PURE__*/ react.createElement((dist_default()), {
        email: props.userEmail,
        size: 16,
        rating: "pg",
        default:  false ? 0 : "monsterid",
        className: css({
            ...(0,utils/* expandBorderRadii */.uJ)("50%")
        })
    }), /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.userEmail), /*#__PURE__*/ react.createElement(AccordionExpandIcon/* AccordionExpandIcon */.K, {
        direction: menuOpen ? "up" : "down"
    }))));
});

;// CONCATENATED MODULE: ./src/components/chrome/NotFound.tsx






const ErrorNavBar = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    const logoProps = {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            height: "46px",
            cursor: "pointer"
        })
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            top: "0",
            left: "0",
            height: 53,
            paddingBottom: "30px",
            paddingTop: "32px",
            paddingLeft: "40px",
            paddingRight: "40px"
        })
    }, props.logoOnly ? /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.M, logoProps) : /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoType */.u, logoProps), props.showButtons ? /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignContent: "center",
            alignItems: "center"
        })
    }, /*#__PURE__*/ react.createElement("a", {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            cursor: "pointer",
            fontFamily: "Inconsolata,monospace",
            fontWeight: 500,
            fontSize: $theme.sizing.scale650
        })
    }, "Login"), /*#__PURE__*/ react.createElement(components_MarketingButton, {
        $style: {
            height: "47px",
            marginLeft: "32px",
            backgroundColor: "#4242fc",
            borderColor: "#11118f",
            color: "#fff",
            padding: "11px 16px 13px 16px",
            fontSize: "18px",
            boxSizing: "border-box",
            boxShadow: "inset 0 3px 0 0 #7575ff,inset 0 -4px 0 0 #2b2bd9",
            ":hover": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#11118f",
                boxShadow: "inset 0 2px 0 0 #2b2bd9, inset 0 -2px 0 0 #7575ff"
            },
            ":active": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#030347",
                boxShadow: "inset 0 4px 0 0 #7575ff"
            }
        },
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/signup`;
        }
    }, "Sign Up")) : /*#__PURE__*/ react.createElement("div", null, props.user && /*#__PURE__*/ react.createElement(UserDropdown, {
        userEmail: props.user
    })));
};
const NotFound = (props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.hQ)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ react.createElement(Column/* Column */.s, {
        $gap: $theme.sizing.scale600,
        $style: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, null, /*#__PURE__*/ react.createElement("span", {
        style: {
            ...$theme.typography.MonoHeadingSmall,
            fontSize: "24px",
            fontWeight: 700
        }
    }, "404: Page not found")), /*#__PURE__*/ react.createElement(Row/* Row */.X, null, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        onClick: props.onBackToGadget ?? function() {
            window.location.href = rootURL;
        }
    }, "Back to Gadget"))));
};


/***/ }),

/***/ 90290:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: () => (/* binding */ EmptyStateCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71567);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45199);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63034);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86358);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75874);




const EmptyStateCard = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
        $style: {
            alignItems: props.fullSize ? "stretch" : "center",
            justifyContent: "center",
            flex: "1",
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .marginUtil */ .SI)($theme.sizing.scale600)
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__/* .Column */ .s, {
        $gap: $theme.sizing.scale800,
        $style: {
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .uJ)($theme.borders.radius200),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .paddingUtil */ .N1)(props.slimPadding ? $theme.sizing.scale800 : $theme.sizing.scale1000),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBaseWebBorder */ .yc)({
                borderWidth: "1px",
                borderStyle: "dashed",
                borderColor: $theme.colors.borderOpaque
            }),
            alignItems: "center",
            justifyContent: "center",
            maxWidth: props.maxWidth,
            flex: props.fullSize ? 1 : undefined,
            ...props.$style
        }
    }, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Heading__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X, {
        $style: {
            textAlign: "center"
        }
    }, props.title), "message" in props && props.message && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
        $style: {
            textAlign: "center"
        }
    }, props.message), "children" in props && props.children, props.actions && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
        $gap: $theme.sizing.scale500
    }, props.actions)));
};


/***/ })

}]);